var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 7.5L5.99902 3.3L7.19902 1.5H10.799L11.999 3.3L8.99902 7.5ZM11.624 5.1L10.724 6.375C12.374 7.05 13.499 8.625 13.499 10.5C13.499 11.6935 13.0249 12.8381 12.181 13.682C11.3371 14.5259 10.1925 15 8.99902 15C7.80555 15 6.66096 14.5259 5.81704 13.682C4.97313 12.8381 4.49902 11.6935 4.49902 10.5C4.49902 8.625 5.62402 7.05 7.27402 6.375L6.37402 5.1C4.34902 6.075 2.99902 8.1 2.99902 10.5C2.99902 12.0913 3.63116 13.6174 4.75638 14.7426C5.8816 15.8679 7.40773 16.5 8.99902 16.5C10.5903 16.5 12.1164 15.8679 13.2417 14.7426C14.3669 13.6174 14.999 12.0913 14.999 10.5C14.999 8.1 13.649 6.075 11.624 5.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/Ring.4ccc8c4380917bf3b00752e5167d47ed.svg";
export { ForwardRef as ReactComponent };